// extracted by mini-css-extract-plugin
export default {"fieldInformation":"styles-module__fieldInformation__b4a8eefb0da33dff183e"};